﻿import config from "../config"
const baseUrl = config.base_url + "lz_tree_image/"
export default {
    statistics: {
        url:  baseUrl + "statistics",
        type: "post",
    },
}

